import { Stack } from '@mui/material';
import RachelFilePartView from '../../../../../RachelMessagePart/components/RachelFilePartView/RachelFilePartView';
import { ExecuteCodeOutputFile } from '../../useRachelAssistantMessage';

interface RachelExecuteCodeFilesProps {
  files: ExecuteCodeOutputFile[];
}

const RachelExecuteCodeFiles = ({ files }: RachelExecuteCodeFilesProps) => {
  return (
    <Stack gap={1} sx={{ alignItems: 'flex-start' }}>
      {files.map((file) => (
        <RachelFilePartView
          key={file.url}
          part={{
            type: 'file',
            mediaType: 'application/octet-stream',
            filename: file.nome,
            url: file.url,
          }}
        />
      ))}
    </Stack>
  );
};

export default RachelExecuteCodeFiles;
